module.exports = __webpack_public_path__ + "img/MEDIA065.d97b1a1b.jpg";